import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/common/SEO';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { lessonsAPI } from '../services/api';

export default function LessonDetailPage() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [lesson, setLesson] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    lessonsAPI.getOne(id).then((res) => setLesson(res.data.data)).catch(() => {}).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <LoadingSpinner className="py-32" />;
  if (!lesson) return <p className="text-center py-20">{t('common.noResults')}</p>;

  return (
    <>
      <SEO title={lesson.title} description={lesson.shortDescription} />
      <article className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/learn" className="text-brand-600 text-sm mb-4 inline-block">← {t('common.back')}</Link>
        <span className="text-sm text-gray-500">{lesson.categoryTitle}</span>
        <h1 className="text-3xl font-display font-bold mt-2 mb-4">{lesson.title}</h1>
        <p className="text-gray-500 mb-6">{lesson.shortDescription}</p>
        {lesson.videoUrl && (
          <div className="aspect-video bg-gray-200 dark:bg-gray-800 rounded-xl mb-6 flex items-center justify-center">
            <a href={lesson.videoUrl} target="_blank" rel="noreferrer" className="btn-primary">Watch Video</a>
          </div>
        )}
        <div className="prose dark:prose-invert max-w-none leading-relaxed whitespace-pre-wrap">
          {lesson.fullContent}
        </div>
        {lesson.tags?.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-8">
            {lesson.tags.map((tag) => (
              <span key={tag} className="px-3 py-1 bg-brand-100 dark:bg-brand-900 text-brand-700 dark:text-brand-300 rounded-full text-sm">#{tag}</span>
            ))}
          </div>
        )}
      </article>
    </>
  );
}
